import { Trans, useLingui } from '@lingui/react/macro';

import Badge from '@/design_system/Badge';
import Box from '@/design_system/Box';
import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import { AGREEMENT_TYPE_INFO, AgreementFromGetById } from '@/models/agreements';

export const AgreementTypeInfo = ({ type }: { type: AgreementFromGetById['type'] }) => {
  const { i18n } = useLingui();
  const typeInfo = AGREEMENT_TYPE_INFO[type];

  return (
    <Box>
      <Stack row gap="0.5rem" alignItems="center">
        <InlineText weight="medium">
          <Trans id="settings.organization.entities.agreements.detail.type.label">Type:</Trans>
        </InlineText>
        <Badge size="large" color={typeInfo.badgeColor}>
          {i18n._(typeInfo.label)}
        </Badge>
      </Stack>
    </Box>
  );
};
